import * as XLSX from 'xlsx';

export interface ExportColumn {
  key: string;
  header: string;
  accessor?: (row: any) => any;
}

export const exportToExcel = (
  data: any[],
  columns: ExportColumn[],
  filename: string = 'export'
) => {
  if (!data || data.length === 0) {
    throw new Error('No data to export');
  }

  const worksheetData = data.map((row) => {
    const rowData: Record<string, any> = {};
    columns.forEach((column) => {
      if (column.accessor) {
        rowData[column.header] = column.accessor(row);
      } else {
        const keys = column.key.split('.');
        let value = row;
        for (const key of keys) {
          value = value?.[key];
          if (value === undefined || value === null) break;
        }
        rowData[column.header] = value ?? '';
      }
    });
    return rowData;
  });

  const worksheet = XLSX.utils.json_to_sheet(worksheetData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

  const maxWidth = 50;
  const colWidths = columns.map((col) => {
    const maxLength = Math.max(
      col.header.length,
      ...worksheetData.map((row) => {
        const value = String(row[col.header] || '');
        return value.length;
      })
    );
    return { wch: Math.min(maxLength + 2, maxWidth) };
  });
  worksheet['!cols'] = colWidths;

  const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${filename}_${new Date().toISOString().split('T')[0]}.xlsx`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};
